import { createContext } from 'react';

type GroupContextType = {
  hasAmbiguousRules: boolean;
};

export const GroupDefaultContext: GroupContextType = {
  hasAmbiguousRules: false,
};

export const GroupContext = createContext<GroupContextType>(GroupDefaultContext);
